import { useState, useEffect, useMemo } from "react";

import styled from "styled-components";



const Div = styled.div`
  width: 98%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-color: #fff;
  border-radius: 0px 0px 15px 15px;
`;

const Table = styled.table`
  width: 98%;
  background-color: #fff;
  padding: 20px 20px;
  box-shadow: 0px 0px 2px #ccc;
  border-radius: 0.5px;
  margin: 1%;

`;



const Thead = styled.thead``;

const Tbody = styled.tbody`
  padding-bottom: 25px; 
`;

const Tr = styled.tr`
  text-align: center;
  &:hover {
    color: black;
    background-color: #f5f5f5;
  }

`;

const Th = styled.th`
  color: #4f4f4f;
  text-align: start;
  border-bottom: inset;
  padding-bottom: 5px;


`;


const Td = styled.td`
  word-break: break-word;
  padding-top: 15px;
  padding-bottom: 5px;
  text-align: ${(props) => (props.alignCenter ? "center" : "start")};
  width: ${(props) => (props.width ? props.width : "auto")};

  @media (max-width: 768px) {
    word-break: none;
    text-align: center;
  }
 

`;




const Grid = ({ acessoModulo }) => {










  //---------------------------------------------ORDENAÇÂO DA PAGINA-----------------------------------------------------------------//
  //Paginação
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;


  // Estado para Ordenação
  const [sortConfig, setSortConfig] = useState(null);

  // Função de Ordenação (agora aplicada ANTES da paginação)
  const sortedData = useMemo(() => {
    let sortableData = [...acessoModulo];

    if (sortConfig !== null) {
      sortableData.sort((a, b) => {
        const aValue = sortConfig.key.split('.').reduce((o, i) => o[i], a);
        const bValue = sortConfig.key.split('.').reduce((o, i) => o[i], b);

        if (aValue < bValue) {
          return sortConfig.direction === "ascending" ? -1 : 1;
        }
        if (aValue > bValue) {
          return sortConfig.direction === "ascending" ? 1 : -1;
        }
        return 0;
      });
    }

    return sortableData;
  }, [acessoModulo, sortConfig]);

  //---------------------------------------EFEITO DE PAGINACAO---------------------------------------------------//

  //Paginação
  // Defina a quantidade de itens por página conforme necessário
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = sortedData.slice(indexOfFirstItem, indexOfLastItem);


  // Função para Alterar Ordenação
  const onColumnClick = (key) => {
    let direction = "ascending";

    if (sortConfig && sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending";
    }

    setSortConfig({ key, direction });
    setCurrentPage(1); // Reseta para a primeira página ao ordenar
  };

  // Função para obter a classe CSS da coluna ordenada
  const getSortClass = (key) => {
    return sortConfig?.key === key ? "sorted-column" : "";
  };

  // Função para exibir o ícone de ordenação (▲ ou ▼)
  const getSortIcon = (key) => {
    if (sortConfig?.key !== key) return "↕"; // Ícone neutro quando não ordenado
    return sortConfig.direction === "ascending" ? "▲" : "▼";
  };

  return (

    <Div>

      {/* Tabela */}
      <Table>
        <Thead>
          <Tr>
            <Th onClick={() => onColumnClick("DESC_MODULO")} className={getSortClass("DESC_MODULO")}>
              Módulo: {getSortIcon("DESC_MODULO")}
            </Th>
            <Th onClick={() => onColumnClick("TOTAL_ACESSOS")} className={getSortClass("TOTAL_ACESSOS")}>
              Data do acessos: {getSortIcon("TOTAL_ACESSOS")}
            </Th>
          </Tr>
        </Thead>
        <Tbody>
          {currentItems.map((item, i) => (
            <Tr key={i} >
              <Td width="auto">{item.DESC_MODULO}</Td>
              <Td width="auto">{item.TOTAL_ACESSOS}</Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </Div>
  );
};


export default Grid;
